export function formatCurrency(amount) {
  // console.log(amount)
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(amount);
}

export const formatDocument = documento => {
  if (documento) {
    documento = removeLiterals(documento);
    if (documento.length <= 11) {
      return documento.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
    return documento.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
      '$1.$2.$3/$4-$5',
    );
  } else return "-"
};

export const formatCep = cep => {
  if (cep.length === 8) {
    return cep.replace(/(\d{5})(\d{3})/, '$1-$2');
  }
};

export const removeLiterals = value => {
  return value.split(/\D/).join('');
};

export const ConvertDateDoMounth = (date) => {
  if (date) {
    const BruteDate = date.toISOString().split("T")[0].split("-");
    const month = BruteDate[1];
    const year = BruteDate[0];
    const dateQuery = `${month}/${year}`;

    return dateQuery;
  } else return date
};

export default formatDocument;


